/**
 * Faceta Pessoas do Localizador.
 *
 * Mesma primitiva e mesmos parâmetros já validados na busca pessoa-cêntrica da
 * Inbox: 2 caracteres, limite 3, debounce de 300 ms, `keepPreviousData` para não
 * piscar entre teclas.
 *
 * A LINHA leva só rótulo + identificador. O card alto (total real, 4 episódios,
 * ações) é `preview` e vive no painel direito — é isso que resolve a pauta 2 da
 * rodada de design sem quebrar D5. Medido nos mockups: com o card na lista a
 * seção custaria 828 px; como linha, custa 102 px.
 */
import { useCapability } from '../../hooks/use-capability';
import { usePersons } from '../persons/use-persons';

import { useDebounced } from './use-debounced';

import type { SpotlightItem } from './types';

export const PEOPLE_MIN_CHARS = 2;
export const PEOPLE_LIMIT = 3;

export function usePeopleHits(term: string): SpotlightItem[] {
  const canRead = useCapability('person-read');
  const debounced = useDebounced(term.trim());
  const enabled = canRead && debounced.length >= PEOPLE_MIN_CHARS;
  const { data } = usePersons({ q: debounced, limit: PEOPLE_LIMIT }, enabled, {
    keepPreviousData: true,
  });
  if (!enabled) return [];
  return (data?.data ?? []).map((p) => ({
    key: `person:${p.id}`,
    section: 'people' as const,
    label: p.displayName,
    ...(p.primaryIdentifierValue !== null && { meta: p.primaryIdentifierValue }),
    to: `/pessoas/${p.id}`,
    // A pessoa inteira, não o id: a linha já a buscou, e o card do painel
    // renderiza nome e identificador direto daqui.
    preview: { kind: 'person' as const, person: p },
  }));
}
